module.exports = __webpack_public_path__ + "static/media/right.3fe288db.svg";